<template>
  <ul class="dui-expandable-options">
    <DuiExpandableOption
      v-for="(option, index) in availableOptions"
      :key="index"
      :option="option"
      @option-selected="optionSelected"
    />
  </ul>
</template>

<script>
import DuiExpandableOption from './dui-expandable-option.vue';
import storeKey from '@dui/mixins/store-key';

export default {
  components: {
    DuiExpandableOption,
  },
  mixins: [
    storeKey,
  ],
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  computed: {
    availableOptions() {
      return this.loadFromStore();
    },
  },
  watch: {
    value: function(newVal) {
      this.deselectAllOptions();
      this.selectOption(this.availableOptions, newVal);
    },
  },
  methods: {
    deselectAllOptions() {
      this.deselectOptions(this.availableOptions);
    },

    deselectOptions(options) {
      if (!options) {
        return;
      }

      options.forEach((option) => {
        this.$set(option, 'selected', false);
        this.deselectOptions(option.options);
      });
    },

    selectOption(options, selectedOption) {
      if (!options) {
        return false;
      }

      let found = false;

      options.forEach((option) => {
        const isParentOption = this.selectOption(option.options, selectedOption);
        if (isParentOption || option === selectedOption) {
          this.$set(option, 'expanded', true);
          this.$set(option, 'selected', true);
          found = true;
        }
      });

      return found;
    },

    // Events
    async optionSelected(option) {
      this.deselectAllOptions();
      this.selectOption(this.availableOptions, option);
      this.$emit('input', option);
      this.$emit('change');

      if (this.storeUpdateKey) {
        this.$store.dispatch(this.storeUpdateKey, option);
      }
    },
    // END Events
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";

ul.dui-expandable-options,
ul.dui-expandable-options .dui-expandable-option ul {
  list-style: none;
}

ul.dui-expandable-options {
  margin: 0;
  padding: 0;

  > .dui-expandable-option:first-child {
    margin-top: 0;
  }

  .dui-expandable-option {
    font-weight: normal;
    margin-top: $_1-5em;

    a.expand-toggle,
    a.option-text {
      position: relative;
    }

    a.option-text {
      font-weight: normal;

      @include transition((
        color
      ), $transition-time-fast);
    }

    &.expanded > ul {
      max-height: initial;
      opacity: 1;
    }

    &.has-options {
      a.expand-toggle {
        display: inline-block;
        height: $_1-5em;
        width: $_1-5em;

        svg {
          height: 9px;
          left: 0;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 10px;

          g#triangle-container {
            transform: matrix(0, -1, 1, 0, 0, 9.042801);

            @include transition((
              transform
            ), $transition-time-fast);

            g#triangle {
              @include transition((
                background-color
              ), $transition-time-fast);
            }
          }
        }
      }
    }

    &.has-options.expanded > a.expand-toggle > svg {
      g#triangle-container {
        transform: matrix(1, 0, 0, 1, 0.042801, 0);
      }
    }

    &.has-options.selected > a.expand-toggle > svg {
      g#triangle {
        fill: getColor($yellow, medium);
      }
    }

    &.no-options a.option-text {
      padding-left: $_2em;

      &:before {
        background-color: getColor($black);
        border-radius: 50%;
        content: " ";
        height: $_0-5em;
        left: 2px;
        position: absolute;
        top: 10px;
        width: $_0-5em;

        @include transition((
          background-color
        ), $transition-time-fast);
      }
    }

    &.no-options.selected > a.option-text:before {
      background-color: getColor($yellow, medium);
    }

    &.selected > a.option-text {
      color: getColor($yellow, medium);
    }

    > a.option-text {
      color: getColor($black);
    }

    ul {
      max-height: 0;
      opacity: 0;
      overflow: hidden;
      padding-left: $_2em;

      @include transition((
        max-height,
        opacity
      ));
    }
  }
}
</style>
